import { neon } from '@neondatabase/serverless';

const sql = neon(process.env.REACT_APP_NEON_DATABASE_URL);

export const saveRankingsToNeon = async (rankings, sessionId) => {
  try {
    console.log('Saving rankings to Neon:', { rankings, sessionId });
    await sql`
      INSERT INTO rankings (session_id, ranking_data, type, created_at)
      VALUES (${sessionId}, ${JSON.stringify(rankings)}, 'final', NOW())
    `;
  } catch (error) {
    console.error('Error saving to Neon:', error);
    throw error;
  }
};

export const saveComparisonToNeon = async (sessionId, questionKey, item1, item2, value) => {
  try {
    console.log('Saving comparison to Neon:', { sessionId, questionKey, item1, item2, value });
    await sql`
      INSERT INTO comparisons (session_id, question_key, item1, item2, preference_value)
      VALUES (${sessionId}, ${questionKey}, ${item1}, ${item2}, ${value})
    `;
  } catch (error) {
    console.error('Error saving comparison to Neon:', error);
    throw error;
  }
};

export const saveQuestionResultsToNeon = async (rankings, sessionId, questionKey) => {
  try {
    console.log('Saving question results to Neon:', { rankings, sessionId, questionKey });
    const rankingData = {
      ...rankings,
      metrics: rankings.metrics
    };
    
    await sql`
      INSERT INTO rankings (session_id, ranking_data, type, metrics, created_at)
      VALUES (${sessionId}, ${JSON.stringify(rankings)}, ${questionKey}, ${JSON.stringify(rankings.metrics)}, NOW())
    `;
  } catch (error) {
    console.error('Error saving to Neon:', error);
    throw error;
  }
};

export const getSessionResults = async (sessionId) => {
  try {
    console.log('Getting session results from Neon:', { sessionId });
    const results = await sql`
      SELECT * FROM rankings 
      WHERE session_id = ${sessionId} 
      ORDER BY created_at ASC
    `;
    
    return results.map(result => ({
      ...result,
      ranking_data: typeof result.ranking_data === 'string' 
        ? JSON.parse(result.ranking_data) 
        : result.ranking_data
    }));
  } catch (error) {
    console.error('Error getting session results from Neon:', error);
    throw error;
  }
};